import { useI18n } from "../../i18n/I18nProvider";

export type StatusFilterValue = "active" | "deleted";

/** Segmented "Active | Deleted" filter shared by the roster and configuration lists. */
export function StatusFilter({
  value,
  onChange,
}: {
  value: StatusFilterValue;
  onChange: (next: StatusFilterValue) => void;
}) {
  const { t } = useI18n();
  const options: { value: StatusFilterValue; label: string }[] = [
    { value: "active", label: t("common.filterActive") },
    { value: "deleted", label: t("common.filterDeleted") },
  ];
  return (
    <div
      role="group"
      aria-label={t("common.deleted")}
      className="inline-flex rounded-control border border-edge bg-board p-0.5"
    >
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          aria-pressed={value === option.value}
          onClick={() => onChange(option.value)}
          className={`min-h-11 rounded-[8px] px-3 text-note font-semibold transition-colors duration-[120ms] sm:min-h-9 ${value === option.value ? "bg-blue text-white" : "text-ink-2 hover:text-ink"}`}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
